import { db } from "../../services/firebase/Config";
import firebase from "firebase/app";
import {
  ABONO_CUENTA,
  SET_CUENTA,
  NEW_CUENTA,
  DEVOLUCION_CUENTA,
} from "./cuentaTypes";

import { httpRequest, httpSuccess, httpFailure } from "../sesion/sesionActions";

export const setCuenta = (cuenta) => {
  return {
    type: SET_CUENTA,
    payload: cuenta,
  };
};
export const newCuenta = () => {
  return {
    type: NEW_CUENTA,
  };
};

const abonoCuenta = (monto) => {
  return {
    type: ABONO_CUENTA,
    payload: monto,
  };
};

const devolucionCuenta = (monto) => {
  return {
    type: DEVOLUCION_CUENTA,
    payload: monto,
  };
};

export const abonarCuenta = (cuenta, monto) => {
  return function (dispatch) {
    dispatch(httpRequest());
    db.collection("empresas").doc(cuenta.empresaId).collection("pacientes").doc(cuenta.pacienteId).collection("cuentas")
      .doc(cuenta.id)
      .update({ saldo: monto })
      .then(() => {
        dispatch(httpSuccess());
        cuenta.saldo = monto;
        dispatch(setCuenta(cuenta));
      })
      .catch((error) => {
        dispatch(httpFailure(error));
      });
  };
};

export const crearCuenta = (paciente) => {
  if (!paciente || !paciente.id) {
    throw new Error("Datos de paciente incompletos para crear cuenta");
  }

  return function (dispatch) {
    dispatch(httpRequest());
    const empresaId = paciente.empresaId;
    // Uses paciente.id as the account ID, similar to previous root collection logic
    let cuentaRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(paciente.id).collection("cuentas").doc(paciente.id);
    let cuenta = {
      adeudado: 0,
      id: cuentaRef.id,
      pacienteId: paciente.id,
      saldo: 0,
      empresaId: paciente.empresaId,
      paciente: { ...paciente, patologias: [] }
    };
    cuentaRef
      .set(cuenta)
      .then(() => {
        dispatch(httpSuccess());
        dispatch(setCuenta(cuenta));
      })
      .catch((err) => {
        dispatch(httpFailure(err));
      });
  };
};

export const abonarCuentaTrx = (abono) => {
  return function (dispatch, getState) {
    // Validación inicial
    if (!abono || !abono.cuentaId || !abono.monto) {
      dispatch(httpFailure(new Error("Datos de abono incompletos")));
      return;
    }

    if (!abono.pacienteId) {
      dispatch(httpFailure(new Error("Falta pacienteId en los datos de abono")));
      return;
    }
    
    const empresaId = abono.empresaId || getState().paciente.empresaId;

    // Validación de tipo numérico
    const monto = Number(abono.monto);
    if (isNaN(monto) || monto <= 0) {
      dispatch(httpFailure(new Error("Monto debe ser un número positivo")));
      return;
    }

    dispatch(httpRequest());

    const batch = db.batch();
    const cuentasRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(abono.pacienteId).collection("cuentas").doc(abono.cuentaId);
    // Updated to use the new centralized path under empresa
    const movimientosRef = db.collection("empresas").doc(empresaId).collection("movimientos").doc();

    try {
      // Operaciones batch
      batch.update(cuentasRef, {
        saldo: firebase.firestore.FieldValue.increment(monto),
      });

      batch.set(movimientosRef, {
        ...abono,
        monto: monto, // Asegurar que es número
        fecha: firebase.firestore.FieldValue.serverTimestamp(), // Mejor práctica
        tipo: 'abono', // Identificación clara
        empresaId: empresaId
      });

      batch.commit()
        .then(() => {
          dispatch(httpSuccess());
          dispatch(abonoCuenta(monto));
        })
        .catch((err) => {
          console.error("Error en commit batch:", err);
          dispatch(httpFailure(err));
        });
    } catch (err) {
      console.error("Error preparando batch:", err);
      dispatch(httpFailure(err));
    }
  };
};
export const devolverCuentaTrx = (devolucion) => {
  return function (dispatch, getState) {
    // 1. Validación inicial de los datos de entrada
    if (!devolucion || !devolucion.cuentaId || !devolucion.monto) {
      dispatch(httpFailure(new Error("Datos de devolución incompletos")));
      return Promise.reject("Datos de devolución incompletos");
    }

    // 2. Validación del tipo y valor del monto
    const monto = Number(devolucion.monto);
    if (isNaN(monto) || monto <= 0) {
      dispatch(httpFailure(new Error("El monto debe ser un número positivo")));
      return Promise.reject("Monto inválido");
    }
    
    const empresaId = devolucion.empresaId || getState().paciente.empresaId;

    // 3. Verificación de saldo suficiente (opcional, si tienes acceso al saldo actual)
    // Esto requeriría una consulta previa a la transacción

    dispatch(httpRequest());

    const batch = db.batch();
    const cuentasRef = db.collection("empresas").doc(empresaId).collection("pacientes").doc(devolucion.pacienteId).collection("cuentas").doc(devolucion.cuentaId);
    // Updated to use the new centralized path under empresa
    const movimientosRef = db.collection("empresas").doc(empresaId).collection("movimientos").doc();

    try {
      // 4. Operación de decremento (con valor negativo)
      batch.update(cuentasRef, {
        saldo: firebase.firestore.FieldValue.increment(-monto),
      });

      // 5. Registro del movimiento con metadatos adicionales
      batch.set(movimientosRef, {
        ...devolucion,
        monto: monto, // Aseguramos que es número
        fecha: firebase.firestore.FieldValue.serverTimestamp(),
        tipo: 'devolucion',
        estado: 'completado',
        empresaId: empresaId
      });

      // 6. Ejecución del batch
      return batch.commit()
        .then(() => {
          dispatch(httpSuccess());
          dispatch(devolucionCuenta(monto));
          return { success: true, monto };
        })
        .catch((err) => {
          console.error("Error en transacción de devolución:", err);
          dispatch(httpFailure(err));
          throw err; // Propaga el error para manejo adicional si es necesario
        });
    } catch (err) {
      console.error("Error preparando transacción de devolución:", err);
      dispatch(httpFailure(err));
      return Promise.reject(err);
    }
  };
};

export const getCuenta = (pacienteId, empresaId) => {
  return function (dispatch) {
    dispatch(httpRequest());
    let cuenta = {};
    if (!empresaId) {
        console.warn("empresaId missing in getCuenta");
        // Potential logic gap if not passed
    }
    return db.collection("empresas").doc(empresaId).collection("pacientes").doc(pacienteId).collection("cuentas")
      .where("pacienteId", "==", pacienteId)
      .get()
      .then((querySnapshot) => {
        querySnapshot.forEach((doc) => {
          cuenta = doc.data();
          cuenta.id = doc.id;
        });
        dispatch(httpSuccess(cuenta));
        dispatch(setCuenta(cuenta));
      })
      .catch((err) => {
        dispatch(httpFailure(err));
        throw err;
      });
  };
};
